export default "__VITE_ASSET__C9kDnWQi__"